import { render } from "./slide2.vue?vue&type=template&id=14e52958&scoped=true"
import script from "./slide2.vue?vue&type=script&lang=js"
export * from "./slide2.vue?vue&type=script&lang=js"

import "./slide2.vue?vue&type=style&index=0&id=14e52958&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e52958"]])

export default __exports__